import { KeyboardKey } from "@/components/keyboard/KeyboardKey";
import { cn } from "@/components/podkit/lib/cn";

/**
 * KeyboardCombo component displays a combination of keyboard keys.
 */
export function KeyboardCombo({ keys, className }: { keys: string[]; className?: string }) {
    return (
        <span className={cn("flex items-center gap-1", "text-[12px] font-normal leading-5")}>
            {keys.map((key, index) => (
                <KeyboardKey key={index} className={cn("text-content-accent", className)}>
                    {key}
                </KeyboardKey>
            ))}
        </span>
    );
}
